<template>
  <van-popup
    class="c-confirm"
    :close-on-click-overlay="false"
    :closeable="false"
    v-model="shown"
    @closed="onClosed"
  >
    <div class="c-confirm-header c:row-center">
      <div class="c-confirm-header-icon"></div>
      <div class="c-confirm-header-title">{{ title || defaultTitle }}</div>
      <div class="c-confirm-header-icon" @click="throttledOnCloseClick">
        <img src="@/assets/icons/closer.svg" alt="" />
      </div>
    </div>
    <div class="c-confirm-body">
      <slot v-if="$slots.default" />
      <template v-else>
        <div class="c-confirm-message">{{ message }}</div>
        <div v-if="desc" class="c-confirm-desc">{{ desc }}</div>
      </template>
    </div>
    <div v-if="footer" class="c-confirm-footer c:row-center">
      <CButton small @click="shown = false">取消</CButton>
      <CButton small primary :disabled="confirmDisabled" @click="onConfirm"
        >确定</CButton
      >
    </div>
  </van-popup>
</template>

<script>
import CButton from "@/components/common/CButton.vue";
import { throttle } from "@/utils";

export default {
  components: {
    CButton,
  },
  props: {
    defaultTitle: {
      type: String,
      default: "",
    },
    footer: {
      type: Boolean,
      default: true,
    },
    confirmDisabled: Boolean,
  },
  data() {
    return {
      shown: false,
      title: "",
      message: "",
      desc: "",
    };
  },
  created() {
    this.throttledOnCloseClick = throttle(() => {
      this.shown = false;
    }, 500);
  },
  methods: {
    show(message) {
      if (!this._promise) {
        this._promise = new Promise((resolve, reject) => {
          this._resolve = resolve;
          this._reject = reject;
        });
      }
      if (typeof message === "string") {
        this.message = message || "";
        this._onBeforeConfirm = null;
      } else if (typeof message === "object" && message !== null) {
        this.message =
          typeof message.message === "string" ? message.message || "" : "";
        this.desc = typeof message.desc === "string" ? message.desc || "" : "";

        this._onBeforeConfirm =
          typeof message.onBeforeConfirm === "function"
            ? message.onBeforeConfirm
            : null;
      } else {
        this.message = "";
      }

      this.shown = true;
      return this._promise;
    },
    hide() {
      this.shown = false;
    },
    onClosed() {
      if (this._reject) {
        this._reject();
        this._promise = null;
        this._resolve = null;
        this._reject = null;
      }
    },
    onConfirm() {
      if (this._onBeforeConfirm && !this._onBeforeConfirm()) {
        return;
      }
      if (this._resolve) {
        this._resolve();
        this._promise = null;
        this._resolve = null;
        this._reject = null;
      }
      this.shown = false;
    },
  },
};
</script>

<style lang="less" scoped>
.c-confirm {
  width: 320/20rem;
  min-height: 100/20rem;
  border-radius: 16/20rem;

  &-header {
    gap: 6/20rem;

    box-sizing: border-box;
    width: 100%;
    height: 38/20rem;
    padding: 10/20rem 10/20rem 6/20rem;

    &-title {
      flex: 1;
      width: 0;
      height: 20/20rem;
      line-height: 20/20rem;
      font-weight: 500;
      font-size: 16/20rem;
      letter-spacing: 0;
      text-align: center;
      color: #000;
    }
    &-icon {
      width: 22/20rem;
      height: 22/20rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  &-body {
    box-sizing: border-box;
    padding: 6/20rem 20/20rem;
  }

  &-message {
    line-height: 20/20rem;
    text-align: center;
    font-weight: 400;
    font-size: 15/20rem;
    letter-spacing: 0;

    color: #000;
  }
  &-desc {
    margin-top: 6/20rem;
    line-height: 17/20rem;
    text-align: center;
    font-weight: 400;
    font-size: 12/20rem;
    letter-spacing: 0.35px;

    color: #7d7d7d;
  }

  &-footer {
    gap: 12/20rem;

    box-sizing: border-box;
    padding: 16/20rem 20/20rem 20/20rem;
  }
}
</style>
